module.exports = __webpack_public_path__ + "static/media/people.00650db5.svg";